/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useEffect, useRef} from 'react';
import translate from './scormTranslate.json';

// --- Run at module load (before any React code) so we never touch parent in cross-origin iframe ---
const inIframe = typeof window !== 'undefined' && window.self !== window.top;
let scormAllowed = true;
if (inIframe) {
  scormAllowed = false;
  try {
    if (window.self.origin === window.top.origin) {
      scormAllowed = true;
    }
  } catch (e) {
    // Reading window.top.origin throws in cross-origin iframe
  }
}
if (typeof window !== 'undefined') {
  console.log('[OLI Tracking] Script loaded. In iframe:', inIframe, '| SCORM allowed:', scormAllowed, '| (Open this frame\'s console: right-click iframe → Inspect → select iframe in frame list → Console)');
}

export default function Tracking(props) {

  const [connected, setConnected] = useState(false);
  const scormRef = useRef(null); // SCORM module when loaded

  const get = (key) => {
    if (!scormRef.current) return '';
    key = translate[props.version][key];
    return scormRef.current.get(key);
  }

  const set = (key, val, autoCommit = false) => {
    if (!scormRef.current) return;
    const translated = translate[props.version][key];
    if (translated !== undefined) {
      key = translated;
    }
    scormRef.current.set(key, val);
    if (autoCommit) {
      commit();
    }
    return scormRef.current.debug.getCode();
  }

  const commit = () => {
    if (!scormRef.current) return;
    scormRef.current.save();
  }

  const getSuspendData = () => {
    const suspend = get('suspend_data');
    if (suspend == null || suspend === '' || suspend === undefined || suspend === 'null') {
      return false;
    }
    return JSON.parse(suspend);
  }

  useEffect(() => {
    let success = false;
    let bookmark = { lessonLocation: '{}', suspendData: false };

    if (scormAllowed) {
      import('pipwerks-scorm-api-wrapper').then(({ SCORM }) => {
        scormRef.current = SCORM;
        try {
          success = SCORM.init();
          if (success) {
            try {
              const locKey = translate[props.version]['lesson_location'];
              const suspKey = translate[props.version]['suspend_data'];
              const loc = locKey !== undefined ? SCORM.get(locKey) : '{}';
              const s = suspKey !== undefined ? SCORM.get(suspKey) : '';
              bookmark = {
                lessonLocation: loc || '{}',
                suspendData: (s == null || s === '' || s === undefined || s === 'null') ? false : JSON.parse(s)
              };
            } catch (e) { /* use default bookmark */ }
            window.onbeforeunload = function () {
              try { SCORM.quit(); } catch (e) { /* ignore */ }
            };
          }
          setConnected(success);
          props.onInit(bookmark);
        } catch (e) {
          if (e.name === 'SecurityError' || e.name === 'DOMException') {
            console.log('[OLI Tracking] SCORM unavailable (e.g. cross-origin iframe), running in demo mode');
          } else {
            console.warn('[OLI Tracking] SCORM init error', e);
          }
          setConnected(false);
          props.onInit(bookmark);
        }
      }).catch((err) => {
        console.warn('[OLI Tracking] Failed to load SCORM wrapper', err);
        setConnected(false);
        props.onInit(bookmark);
      });
    } else {
      console.log('[OLI Tracking] Cross-origin iframe — running in demo mode (no SCORM)');
      setConnected(false);
      props.onInit(bookmark);
    }
  }, [])

  useEffect(() => {
    if (!connected) return;
    console.log("TRACKING index change detected")
    // code to run on component mount
    const bookmark = {
      stepIndex: props.stepIndex,
      moduleIndex: props.moduleIndex
    }
    set('lesson_location', JSON.stringify(bookmark))
    set('suspend_data', JSON.stringify(props.moduleProgress))
  }, [props.stepIndex, props.moduleIndex])

  useEffect(() => {
    if (!connected) return;

    if (props.scoComplete) {
      console.log("TRACKING course completion detected")
      set('lesson_status', translate[props.version]['complete']);
      if (props.scoScored) {
        if (props.version === 'scorm2004') {
          set('success_status', 'passed');
        } else {
          set('success_status', 'failed');
        }
      } else {
        set('success_status', 'passed');
      }
    }
    commit();

    // // hot fix 1/30/2019 - Orion
    // // just remove line below and uncomment code @ 209 in App.js to revert
    // window.top.close();

  }, [props.scoComplete])


  return (
    <div className="Tracking">

    </div>
  )
}
